var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Head',{ref:"head"})],1),_c('div',{staticClass:"route-body"},[_c('div',{staticClass:"center-size"},[_c('router-view',{on:{"headSerach":_vm.headSerach}})],1)]),_c('div',[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }